import { render, staticRenderFns } from "./UserMobileMore.vue?vue&type=template&id=35497608&scoped=true&"
import script from "./UserMobileMore.vue?vue&type=script&lang=js&"
export * from "./UserMobileMore.vue?vue&type=script&lang=js&"
import style0 from "./UserMobileMore.vue?vue&type=style&index=0&id=35497608&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35497608",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35497608')) {
      api.createRecord('35497608', component.options)
    } else {
      api.reload('35497608', component.options)
    }
    module.hot.accept("./UserMobileMore.vue?vue&type=template&id=35497608&scoped=true&", function () {
      api.rerender('35497608', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserMobileMore.vue"
export default component.exports